"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EN_TITLE_WEIGHT = void 0;
/**
 * 글자 굵기를 결정하는 enum 객체로, CSS 일반 명세와 동일하게 작성한다.
 * 이렇게 하는 이유는 어짜피 title이냐 subtitle이냐에 따라서 크기가 달라지기 때문에,
 * 굵기를 먼저 조정한다.
 *
 * via: https://developer.mozilla.org/ko/docs/Web/CSS/font-weight
 */
var EN_TITLE_WEIGHT;
(function (EN_TITLE_WEIGHT) {
    EN_TITLE_WEIGHT[EN_TITLE_WEIGHT["THIN"] = 100] = "THIN";
    EN_TITLE_WEIGHT[EN_TITLE_WEIGHT["EXTRA_LIGHT"] = 200] = "EXTRA_LIGHT";
    EN_TITLE_WEIGHT[EN_TITLE_WEIGHT["LIGHT"] = 300] = "LIGHT";
    /** 이 값이 기본 굵기 */
    EN_TITLE_WEIGHT[EN_TITLE_WEIGHT["NORMAL"] = 400] = "NORMAL";
    EN_TITLE_WEIGHT[EN_TITLE_WEIGHT["MEDIUM"] = 500] = "MEDIUM";
    EN_TITLE_WEIGHT[EN_TITLE_WEIGHT["SEMI_BOLD"] = 600] = "SEMI_BOLD";
    EN_TITLE_WEIGHT[EN_TITLE_WEIGHT["BOLD"] = 700] = "BOLD";
    EN_TITLE_WEIGHT[EN_TITLE_WEIGHT["EXTRA_BOLD"] = 800] = "EXTRA_BOLD";
    EN_TITLE_WEIGHT[EN_TITLE_WEIGHT["BLACK"] = 900] = "BLACK";
})(EN_TITLE_WEIGHT = exports.EN_TITLE_WEIGHT || (exports.EN_TITLE_WEIGHT = {}));
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiRU5fVElUTEVfV0VJR0hULmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsiLi4vLi4vLi4vLi4vLi4vc3JjL3NhcHBvcm8vY29uc3RhbnQvZW51bS90ZXh0L0VOX1RJVExFX1dFSUdIVC50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQTs7Ozs7O0dBTUc7QUFDSCxJQUFZLGVBV1g7QUFYRCxXQUFZLGVBQWU7SUFDekIsdURBQVUsQ0FBQTtJQUNWLHFFQUFpQixDQUFBO0lBQ2pCLHlEQUFXLENBQUE7SUFDWCxpQkFBaUI7SUFDakIsMkRBQVksQ0FBQTtJQUNaLDJEQUFZLENBQUE7SUFDWixpRUFBZSxDQUFBO0lBQ2YsdURBQVUsQ0FBQTtJQUNWLG1FQUFnQixDQUFBO0lBQ2hCLHlEQUFXLENBQUE7QUFDYixDQUFDLEVBWFcsZUFBZSxHQUFmLHVCQUFlLEtBQWYsdUJBQWUsUUFXMUIifQ==